import styled from '@emotion/styled';

interface StyledDivProps {
  color: string;
}

export const StyledDiv = styled.div`
  color: ${({ color }: StyledDivProps) => color};
`;
